const dashboardData = {
   keyStatistics: {
    chartType: 'horizontalBar',
    data: {
        labels: ['Purchase', 'Wastage'],
        datasets: [
            {
                label: 'Amount (₹)',
                backgroundColor: ['#42A5F5', '#EF5350'],
                data: [420000, 35000]
            }
        ]
    }
},
    newPurchase: {
        chartType: 'pie',
        data: {
            labels: [
                'Fresh Vegetables',
                'Chicken',
                'Seafood',
                'Dairy',
                'Spices'
            ],
            datasets: [
                {
                    data: [35, 25, 15, 15, 10],
                    backgroundColor: [
                        '#42A5F5',
                        '#66BB6A',
                        '#FFA726',
                        '#AB47BC',
                        '#EF5350'
                    ]
                }
            ]
        }
    },

    rawMaterial: {
        chartType: 'doughnut',

        data: {
            labels: [
                'Rice',
                'Chicken',
                'Vegetables',
                'Spices'
            ],

            datasets: [
                {
                    data: [40, 30, 20, 10],

                    backgroundColor: [
                        '#42A5F5',
                        '#66BB6A',
                        '#FFA726',
                        '#EF5350'
                    ]
                }
            ]
        }
    },

    wastage: {
        chartType: 'doughnut',

        data: {
            labels: [
                'Rice',
                'Chicken',
                'Vegetables',
                'Others'
            ],

            datasets: [
                {
                    data: [8, 12, 5, 3],

                    backgroundColor: [
                        '#EF5350',
                        '#FFA726',
                        '#AB47BC',
                        '#78909C'
                    ]
                }
            ]
        }
    },

    cogs: {
        chartType: 'bar',
        data: {
            labels: [
                'Food',
                'Beverage',
                'Bakery',
                'Dessert',
                'Others'
            ],
            datasets: [
                {
                    label: 'COGS %',
                    backgroundColor: [
                        '#42A5F5',
                        '#66BB6A',
                        '#FFA726',
                        '#AB47BC',
                        '#EF5350'
                    ],
                    data: [38, 24, 15, 12, 11]
                }
            ]
        }
    },

    stockLevel: {
        chartType: 'bar',
        data: {
            labels: [
                'Rice',
                'Oil',
                'Chicken',
                'Paneer',
                'Flour'
            ],
            datasets: [
                {
                    label: 'Current Stock',
                    backgroundColor: '#42A5F5',
                    data: [95, 70, 55, 40, 88]
                }
            ]
        }
    },

    currentStockPrice: {
        totalValue: '₹ 12,45,780',
        warehouseValue: '₹ 8,15,400',
        kitchenValue: '₹ 4,30,380'
    },

    pendingPurchases: {
        count: 14,
        amount: '₹ 1,82,400',
        buttonText: 'View Purchases'
    },

    // pendingPOApprovals: {
    //     count: 6,
    //     amount: '₹ 72,900',
    //     approvalPendingWith: 'Store Manager'
    // },
    pendingPOApprovals: [
    {
        id: 1,
        title: 'PO-2026-001',

        details: [
            {
                name: 'Vendor',
                value: 'ABC Foods'
            },
            {
                name: 'Amount',
                value: '₹ 25,000'
            }
        ]
    },
]
, 
    // poRaise: {
    //     suggestedItems: 23,
    //     estimatedValue: '₹ 95,000',
    //     buttonText: 'Raise PO'
    // },
    poRaise: [
    {
        supplierId: 1,
        supplierName: 'PRAYOSHA FOODS PVT LTD',

        items: [
            {
                itemName: '100 Piper',
                shortage: '-15 Btls'
            },
            {
                itemName: 'Ashu C',
                shortage: '5 Ltr'
            }
        ]
    },

    {
        supplierId: 2,
        supplierName: 'AD-DUBEY',

        items: [
            {
                itemName: '7 Up',
                shortage: '-12 Btls'
            }
        ]
    },

    {
        supplierId: 3,
        supplierName: 'Saurav ABC',

        items: [
            {
                itemName: 'Rice',
                shortage: '-30 Kg'
            }
        ]
    }
]
,
    consumptionComparison: {
        currentMonth: '₹ 3,85,000',
        previousMonth: '₹ 3,42,000',
        variance: '+12.57%',
        topConsumedItem: 'Chicken'
    }
};

export default dashboardData;